import fetch from 'isomorphic-fetch';
import getBearerToken from './getBearerToken';

/**
 * WorkMarket V3 API helper fetch function.
 *
 * @param {String} url - The request URL endpoint
 * @param {Object} payload - The object that will be POST to the URL specified
 * @param {Object} options - Specify internal options
 * @param {boolean} includeEntireResult - When set to `true`, the `result` object from the response will be returned. Otherwise, only the payload array will be returned.
 *
 * @returns {Promise} Returns a promise with the response payload if resolved.
 */
const wmFetch = async (url, payload, options = {}, includeEntireResult = false) => {
	const fetchOptions = (optionsOverride, token) => {
		const defaultOptions = {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json; charset=utf-8',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(payload)
		};
		return { ...defaultOptions, ...optionsOverride };
	};

	try {
		const apiToken = await getBearerToken();
		const response = await fetch(
			url,
			fetchOptions(options, apiToken)
		);

		const data = await response.json();
		const { result } = data;

		if (Array.isArray(result.errors) && result.errors.length) {
			throw new Error(result.errors[0].message);
		}

		if (Array.isArray(result.payload)) {
			return includeEntireResult ? result : result.payload;
		}
		throw new Error('API responded with an invalid V3 payload.');
	} catch (error) {
		throw error;
	}
};

export default wmFetch;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/funcs/wmFetch.js